import { render, staticRenderFns } from "./EventConfirmModal.vue?vue&type=template&id=0953e38d&scoped=true"
import script from "./EventConfirmModal.vue?vue&type=script&lang=js"
export * from "./EventConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./EventConfirmModal.vue?vue&type=style&index=0&id=0953e38d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0953e38d",
  null
  
)

export default component.exports